import { render, staticRenderFns } from "./KiPilotPraxis.vue?vue&type=template&id=255c15e2"
import script from "./KiPilotPraxis.vue?vue&type=script&lang=ts"
export * from "./KiPilotPraxis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports